import React, { Component } from 'react';
import { createPortal } from 'react-dom';
import styled, { keyframes, withTheme } from 'styled-components';
import { Link, withRouter } from 'react-router-dom';
import HeaderSubMenu from '../HeaderSubMenu';
import NavigationStoreActions from '../../flux/NavigationStoreActions';
import NavigationStore from '../../flux/NavigationStore';
import JwtStore from '../../flux/JwtStore';
import PageLoadingOverlayStore from '../../flux/PageLoadingOverlayStore';
import flexColumns from '../../utils/flexColumns';
import { default as HamburgerMenu } from '../../icons/Menu';
import { default as UserIcon } from '../../icons/User';
import buttonMutedStyle from '../../utils/buttonMutedStyle';
import getSearchQueryFromQueryString
  from '../../utils/getSearchQueryFromQueryString';
import HeaderSearchField from '../HeaderSearchField';
import { default as ReportsIcon } from '../../icons/Reports';
import remToPixels from '../../utils/remToPixels';
import withScrollDirection from '../../hoc/withScrollDirection';
import ArrowUp from '../../icons/ArrowUp';
import HelpIcon from '../../icons/Help';
import ModalFullscreenActions from '../../flux/ModalFullscreenActions';
import ButtonFloating from '../ButtonFloating';
import Color from 'color';
import ArrowLeft from '../../icons/ArrowLeft';
import ValentinoAccademiaLogo from '../../icons/ValentinoAccademiaLogo';
import NotificationModal from "../NotificationModal";
import RenderOnMobile from '../responsive/RenderOnMobile';
import RenderOnTablet from '../responsive/RenderOnTablet';
import themeResponsiveProperty from '../responsive/themeResponsiveProperty';
import { default as GlossaryIcon } from "../../icons/Glossary";
import { default as SearchIcon } from "../../icons/Search";
import { default as CloseIcon } from "../../icons/Close";
import GlossaryFilterIcon from '../GlossaryFilterIcon';
import ModalFullscreenStore from '../../flux/ModalFullscreenStore';
import { SCROLL_DIRECTION_DOWN } from '../../hooks/useScrollDirection';
import __ from "../../utils/translator";

const defaultMobileActions = [
  'profile',
  'search',
  'glossary',
];

const defaultTabletActions = [
  'back',
  'search',
  'reports',
  'profile',
  'help',
  'menu',
];

const actionsHandler = {
  'close-fullscreen-modal': () => ModalFullscreenActions.close(),
};

function pickActionHandler(actionName, actionsHandlerOverride) {
  return typeof actionsHandlerOverride[actionName] === 'function'
    ? actionsHandlerOverride[actionName]
    : actionsHandler[actionName]
}

class Header extends Component {
  state = {
    pageLoadingOverlayVisible: PageLoadingOverlayStore.getState(),
    modalFullscreen: ModalFullscreenStore.getState(),
    scrollDirection: this.props.scrollDirection,

    isSubMenuOpen: false,
    collections: [],
    categories: [],
    reportCollectionId: null,
    hasAnyArchivedCollection: false,
    unseenProductFocuses: [],

    isSearchFieldActive: false,
    searchQuery: getSearchQueryFromQueryString(this.props.location.search),
  };

  subscriptions = [];
  searchFieldReference = null;

  componentDidMount() {
    NavigationStoreActions.getNavigation();

    this.subscriptions.push(PageLoadingOverlayStore.addListener(() => {
      this.setState({
        pageLoadingOverlayVisible: PageLoadingOverlayStore.getState(),
      })
    }));

    this.subscriptions.push(ModalFullscreenStore.addListener(() => {
      this.setState({
        modalFullscreen: ModalFullscreenStore.getState(),
      })
    }));

    this.subscriptions.push(NavigationStore.addListener(() => {
      this.setState({
        collections: NavigationStore.getState().collections,
        categories: NavigationStore.getState().categories,
        reportCollectionId: NavigationStore.getState().reports_collection_id,
        hasAnyArchivedCollection: NavigationStore.getState().has_any_archived_collection,
        hasAnyUnreadNews: false, //NavigationStore.getState().has_any_unread_news,
        unseenProductFocuses: [], // NavigationStore.getState().unseen_product_focuses,
      });
    }));
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.scrollDirection !== prevState.scrollDirection) {
      return { scrollDirection: nextProps.scrollDirection, };
    }

    return null;
  }

  componentDidUpdate(prevProps) {
    const pathDidChange = (
      this.props.location.pathname !== prevProps.location.pathname ||
      this.props.location.search !== prevProps.location.search
    );

    let nextState = null;

    if (pathDidChange) {
      if (this.searchFieldReference !== null) {
        this.searchFieldReference.blur();
      }

      nextState = {
        ...nextState,
        isSubMenuOpen: false,
        isSearchFieldActive: false,
      };
    }

    if (
      this.props.scrollDirection === SCROLL_DIRECTION_DOWN &&
      this.state.isSearchFieldActive === true
    ) {
      nextState = {
        ...nextState,
        isSearchFieldActive: false,
      };
    }

    if (nextState !== null) {
      this.setState(nextState);
    }
  }

  componentWillUnmount() {
    this.subscriptions.forEach(subscription => subscription.remove());
  }

  toggleSubMenu = event => {
    event.preventDefault();
    this.setState({ isSubMenuOpen: ! this.state.isSubMenuOpen });
  };

  onGoToTopClick = event => {
    event.preventDefault();
    window.scrollTo(0, 0);
  };

  render() {
    const actions = this.props.actions !== undefined
      ? this.props.actions
      : themeResponsiveProperty(defaultMobileActions, defaultTabletActions)(this.props);

    return (
      <React.Fragment>
        <RenderOnTablet>
          {createPortal(
            <GoToTop isVisible={this.state.scrollDirection === 'UP'} onClick={this.onGoToTopClick}>
              <ArrowUp style={{ width: '1.5rem', height: '1.5rem', }}/>
            </GoToTop>,
            window.document.body
          )}
        </RenderOnTablet>

        {(this.state.hasAnyUnreadNews || this.state.unseenProductFocuses.length > 0) && (
          createPortal(
            <NotificationModal
              hasNews={this.state.hasAnyUnreadNews}
              unseenProductFocus={this.state.unseenProductFocuses}
            />,
            window.document.body
          )
        )}

        <NavigationBarContainer isVisible={(
          this.state.scrollDirection === null ||
          this.state.scrollDirection === 'UP' ||
          this.state.isSubMenuOpen ||
          this.state.modalFullscreen.isVisible
        )}>
          {this.state.pageLoadingOverlayVisible && (
            <Loader />
          )}

          <NavigationBar columns={['calc(50% - 5.75rem)', '11.5rem', 'calc(50% - 5.75rem)']}>
            <RenderOnTablet>
              <HeaderLeftContainer>
                {actions.includes('back') && (
                  <button
                    onClick={this.props.history.goBack}
                    style={{ ...headerMenuNavLinkStyle, ...buttonMutedStyle, padding: '0 .75rem', }}>
                    <ArrowLeft style={{ width: '1.25rem', height: '1.25rem', flexShrink: 0 }} />
                  </button>
                )}
              </HeaderLeftContainer>
            </RenderOnTablet>

            <Logo>
              <Link to="/" style={logoAnchorStyle}>
                <StyledValentinoAccademiaLogo />
              </Link>
            </Logo>

            <HeaderRightContainer>
              {actions.includes('search') && (
                <React.Fragment>
                  <RenderOnMobile>
                    <button
                      onClick={() => ModalFullscreenActions.search()}
                      style={{ ...headerMenuNavLinkStyle, ...buttonMutedStyle, padding: '0 .75rem', }}>
                      <SearchIcon style={{ width: '1.5rem', height: '1.5rem', }} />
                    </button>
                  </RenderOnMobile>

                  <RenderOnTablet>
                    <HeaderSearchField
                      inputRef={ref => this.searchFieldReference = ref}
                      value={this.state.searchQuery}
                      onChange={searchQuery => this.setState({ searchQuery })}
                      isOpen={this.state.isSearchFieldActive}
                      handleOpenChange={isOpen => this.setState({ isSearchFieldActive: isOpen })}
                      onSubmit={() => {
                        this.props.history.push(`/search?q=${this.state.searchQuery}`);
                      }} />
                  </RenderOnTablet>
                </React.Fragment>
              )}

              {actions.includes('glossary') && (
                <RenderOnMobile>
                  <button
                    onClick={() => ModalFullscreenActions.glossary()}
                    style={{ ...headerMenuNavLinkStyle, ...buttonMutedStyle, padding: '0 .75rem', }}>
                    <GlossaryIcon style={{ width: '1.5rem', height: '1.5rem'}} />
                  </button>
                </RenderOnMobile>
              )}

              {actions.includes('reports') && (
                <RenderOnTablet>
                  {(JwtStore.canViewReport() || JwtStore.isStoreAssistant() || JwtStore.isOffice()) && (
                    <Link
                      to={this.state.reportCollectionId ? `/reports/seasonal/${this.state.reportCollectionId}` : '#'}
                      style={{ ...headerMenuNavLinkStyle, ...buttonMutedStyle, padding: '0 .75rem', }}>
                      <ReportsIcon style={{ width: '1.25rem', }} />
                    </Link>
                  )}
                </RenderOnTablet>
              )}

              {actions.includes('profile') && (
                <>
                  <RenderOnTablet>
                    <Link style={headerMenuNavLinkStyle} to="/profile">
                      <UserIcon style={{ width: '1.25rem', height: '1.25rem', flexShrink: 0, }} />
                    </Link>
                  </RenderOnTablet>
                  <RenderOnMobile>
                    <button
                      onClick={() => ModalFullscreenActions.user()}
                      style={{ ...headerMenuNavLinkStyle, ...buttonMutedStyle, padding: '0 .75rem', }}>
                      <UserIcon style={{ width: '1.5rem', height: '1.5rem', flexShrink: 0, }} />
                    </button>
                  </RenderOnMobile>
                </>
              )}

              {actions.includes('help') && (
                <RenderOnTablet>
                  <button
                    onClick={ModalFullscreenActions.help}
                    style={{ ...headerMenuNavLinkStyle, ...buttonMutedStyle, padding: '0 .75rem', }}>
                    <HelpIcon style={{ width: '1.25rem', }} />
                  </button>
                </RenderOnTablet>
              )}

              {actions.includes('menu') && (
                <RenderOnTablet>
                  <button
                    onClick={this.toggleSubMenu}
                    style={{ ...headerMenuNavLinkStyle, ...buttonMutedStyle, padding: '.5rem .75rem', }}>
                    <HamburgerMenu style={{ width: '1.25rem', }} />
                  </button>
                </RenderOnTablet>
              )}

              {actions.includes('glossary-filter') && (
                <RenderOnMobile>
                  <GlossaryFilterIcon />
                </RenderOnMobile>
              )}

              {actions.includes('close-fullscreen-modal') && (
                <RenderOnMobile>
                  <button
                    onClick={() => pickActionHandler('close-fullscreen-modal', this.props.actionsHandlerOverride)()}
                    style={{ ...headerMenuNavLinkStyle, ...buttonMutedStyle, padding: '0 .75rem', }}>
                    <CloseIcon style={{ width: '1.25rem', height: '1.25rem', }} />
                  </button>
                </RenderOnMobile>
              )}
            </HeaderRightContainer>
          </NavigationBar>

          {actions.includes('back') && (
            <RenderOnMobile>
              <BackButtonContainer>
                <button
                  onClick={this.props.history.goBack}
                  style={{ ...headerMenuNavLinkStyle, ...buttonMutedStyle, padding: '0 .75rem', }}
                >
                  <ArrowLeft style={{ width: '.75rem', height: '.75rem', flexShrink: 0 }} />
                  {__('Back')}
                </button>
              </BackButtonContainer>
            </RenderOnMobile>
          )}

          {this.props.children}

          {this.state.isSubMenuOpen && (
            <HeaderSubMenu
              collections={this.state.collections}
              shouldShowArchiveLink={this.state.hasAnyArchivedCollection}
              categories={this.state.categories}
              onCloseSubMenuClick={this.toggleSubMenu} />
          )}
        </NavigationBarContainer>
      </React.Fragment>
    );
  }
}

Header.defaultProps = {
  actionsHandlerOverride: {},
};

export default withTheme(withScrollDirection(withRouter(Header), remToPixels(3.25), 0, 50));

const GoToTop = styled(ButtonFloating)`
  right: 1rem;
  width: 3rem;
  padding: 0;
`;

const NavigationBarContainer = styled.div`
  z-index: 10001;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  right: 0;
  left: 0;

  transform: translateY(${({ isVisible }) => isVisible ? '0' : '-100%' });
  transition: transform 300ms ease;
  will-change: transform;
`;

const NavigationBar = styled.div`
  overflow-x: hidden;
  display: flex;
  align-items: center;
  justify-content: space-between;
  ${props => flexColumns(props.columns)};
  padding: max(.125rem, env(safe-area-inset-top)) .25rem .125rem;
  line-height: 3.125rem;
  color: ${props => props.theme.primaryIconColor};
  box-shadow: ${props => props.theme.isTablet ? '0 .0625rem .125rem rgba(0,0,0,.05)' : null};
  background-color: ${props => props.theme.secondaryBackgroundColorNegative};
`;

const HeaderLeftContainer = styled.div`
  display: flex;
  align-items: center;

  > a {
    padding: 0 1rem;
  }
`;

const HeaderRightContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  > a {
    padding: 0 1rem;
  }
`;

const Logo = styled.div`
  padding: 0 1rem;
  color: ${props => props.theme.primaryIconColor};
`;

const logoAnchorStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
};

const headerMenuNavLinkStyle = {
  display: 'flex',
  alignItems: 'center'
};

const BackButtonContainer = styled.div`
  background-color: #FFFFFF;
  padding: 1rem 0;
  font-size: 1rem;

  svg {
    margin-right: .5rem;
  }
`

const animation = keyframes`
  from {
    left: -20rem;
    width: 30%;
  }

  40% {
    width: 30%;
  }

  60% {
    width: 50%;
  }

  to {
    left: 110%;
  }
`;

const Loader = styled.div`
  position: absolute;
  right: 0;
  bottom: -.1875rem;
  left: 0;
  height: .1875rem;
  overflow: hidden;
  background-color: ${props => Color(props.theme.primaryBackgroundColor).darken(.1).rgb().string()};

  &:before {
    display: block;
    position: absolute;
    content: "";
    left: -20rem;
    width: 20rem;
    height: .1875rem;
    background-color: ${props => Color(props.theme.primaryBackgroundColor).darken(.2).rgb().string()};
    animation: ${animation} 3s linear infinite;
  }
`;

const StyledValentinoAccademiaLogo = styled(ValentinoAccademiaLogo)`
  width: ${themeResponsiveProperty('9.25rem', '6rem')};
  height: ${themeResponsiveProperty('2.5rem', '1.625rem')};
  // We enforce a spacing to correctly add paddings around the logo
  margin: ${themeResponsiveProperty('.4375rem 0', '.4375rem 0')};
`;
